<template>
  <div class="sidebar">
    <div class="logo">
      <router-link to="/">
        <svg
          width="181"
          height="46"
          viewBox="0 0 181 46"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M56.2441 29.2216C55.9141 29.2481 55.6632 29.2017 55.4916 29.0826C55.3199 28.9635 55.2341 28.7848 55.2341 28.5465C55.2341 28.1097 55.4784 27.8846 55.9669 27.8714L56.561 27.8317C57.2344 27.792 57.7361 27.5868 58.0661 27.2161C58.3962 26.8322 58.5612 26.2233 58.5612 25.3894V15.8584C58.5612 15.6069 58.6405 15.4084 58.7989 15.2627C58.9573 15.1039 59.1488 15.0245 59.3732 15.0245C59.6241 15.0245 59.8221 15.1039 59.9674 15.2627C60.1126 15.4084 60.1852 15.6069 60.1852 15.8584V25.4092C60.1852 26.6271 59.9079 27.5471 59.3534 28.1692C58.7989 28.7781 57.9605 29.1157 56.8383 29.1819L56.2441 29.2216Z"
            fill="white"
          />
          <path
            d="M67.3974 29.2613C66.4864 29.2613 65.681 29.0561 64.9812 28.6458C64.2947 28.2354 63.76 27.653 63.3771 26.8984C63.0074 26.1307 62.8226 25.2438 62.8226 24.2377C62.8226 23.2317 63.0074 22.3514 63.3771 21.5969C63.76 20.8291 64.2947 20.24 64.9812 19.8297C65.681 19.4193 66.4864 19.2141 67.3974 19.2141C68.3083 19.2141 69.1137 19.4193 69.8135 19.8297C70.5132 20.24 71.0479 20.8291 71.4176 21.5969C71.8005 22.3514 71.9919 23.2317 71.9919 24.2377C71.9919 25.2438 71.8005 26.1307 71.4176 26.8984C71.0479 27.653 70.5132 28.2354 69.8135 28.6458C69.1137 29.0561 68.3083 29.2613 67.3974 29.2613ZM67.3974 27.931C68.348 27.931 69.0741 27.6199 69.5758 26.9977C70.0907 26.3623 70.3482 25.4423 70.3482 24.2377C70.3482 23.0596 70.0907 22.1528 69.5758 21.5174C69.0609 20.8688 68.3348 20.5445 67.3974 20.5445C66.4599 20.5445 65.7338 20.8688 65.2189 21.5174C64.704 22.1528 64.4465 23.0596 64.4465 24.2377C64.4465 25.4291 64.6974 26.3425 65.1991 26.9779C65.714 27.6133 66.4467 27.931 67.3974 27.931Z"
            fill="white"
          />
          <path
            d="M81.7096 19.2538C81.9605 19.2538 82.1519 19.3266 82.284 19.4722C82.4292 19.6179 82.5018 19.8098 82.5018 20.0481V28.4472C82.5018 28.6722 82.4292 28.8576 82.284 29.0032C82.1519 29.1488 81.9605 29.2216 81.7096 29.2216C81.472 29.2216 81.2806 29.1554 81.1353 29.023C81.0033 28.8774 80.9373 28.6921 80.9373 28.4671V27.4743C80.6336 28.0567 80.2045 28.5002 79.65 28.8046C79.1087 29.1091 78.4948 29.2613 77.8082 29.2613C76.6596 29.2613 75.7948 28.9436 75.2138 28.3082C74.6329 27.6596 74.3425 26.7065 74.3425 25.4489V20.0481C74.3425 19.8098 74.4151 19.6179 74.5603 19.4722C74.7055 19.3266 74.9036 19.2538 75.1544 19.2538C75.4053 19.2538 75.5967 19.3266 75.7288 19.4722C75.874 19.6179 75.9466 19.8098 75.9466 20.0481V25.4092C75.9466 26.2697 76.1182 26.9051 76.4615 27.3154C76.8048 27.7125 77.3461 27.9111 78.0855 27.9111C78.9304 27.9111 79.6104 27.6397 80.1253 27.097C80.6402 26.541 80.8977 25.813 80.8977 24.9128V20.0481C80.8977 19.8098 80.9703 19.6179 81.1155 19.4722C81.2607 19.3266 81.4588 19.2538 81.7096 19.2538Z"
            fill="white"
          />
          <path
            d="M90.2561 19.2538C90.8106 19.2141 91.0879 19.4392 91.0879 19.9289C91.0879 20.1407 91.0285 20.3128 90.9097 20.4452C90.7908 20.5643 90.5862 20.6371 90.2957 20.6636L89.7016 20.7232C88.817 20.8026 88.1569 21.1203 87.7212 21.6763C87.2987 22.219 87.0874 22.861 87.0874 23.6023V28.4274C87.0874 28.6921 87.0148 28.8907 86.8696 29.023C86.7244 29.1554 86.5329 29.2216 86.2953 29.2216C86.0576 29.2216 85.8596 29.1554 85.7011 29.023C85.5559 28.8774 85.4833 28.6789 85.4833 28.4274V20.0481C85.4833 19.7966 85.5625 19.6046 85.7209 19.4722C85.8794 19.3266 86.0708 19.2538 86.2953 19.2538C86.5065 19.2538 86.6847 19.3266 86.83 19.4722C86.9752 19.6046 87.0478 19.7899 87.0478 20.0282V21.1402C87.3251 20.5577 87.7146 20.1143 88.2163 19.8098C88.7312 19.5053 89.3187 19.3266 89.9789 19.2737L90.2561 19.2538Z"
            fill="white"
          />
          <path
            d="M97.3171 19.2141C99.6276 19.2141 100.783 20.4915 100.783 23.0463V28.4274C100.783 28.6789 100.71 28.8774 100.565 29.023C100.433 29.1554 100.242 29.2216 99.9907 29.2216C99.7398 29.2216 99.5418 29.1554 99.3966 29.023C99.2513 28.8774 99.1787 28.6789 99.1787 28.4274V23.1456C99.1787 22.2455 99.0005 21.5902 98.644 21.1799C98.3007 20.7695 97.7462 20.5643 96.9804 20.5643C96.0958 20.5643 95.3895 20.8357 94.8614 21.3784C94.3333 21.9212 94.0692 22.6558 94.0692 23.5825V28.4274C94.0692 28.6789 93.9966 28.8774 93.8514 29.023C93.7193 29.1554 93.5279 29.2216 93.277 29.2216C93.0262 29.2216 92.8281 29.1554 92.6829 29.023C92.5377 28.8774 92.4651 28.6789 92.4651 28.4274V20.0481C92.4651 19.8098 92.5377 19.6179 92.6829 19.4722C92.8281 19.3266 93.0262 19.2538 93.277 19.2538C93.5147 19.2538 93.6995 19.3266 93.8316 19.4722C93.9768 19.6179 94.0494 19.8032 94.0494 20.0282V21.0409C94.3663 20.4452 94.8086 19.9951 95.3763 19.6907C95.944 19.373 96.591 19.2141 97.3171 19.2141Z"
            fill="white"
          />
          <path
            d="M111.187 26.8786C111.332 26.8786 111.458 26.9381 111.563 27.0573C111.669 27.1764 111.722 27.3287 111.722 27.514C111.722 27.8449 111.491 28.1494 111.029 28.4274C110.553 28.7053 110.052 28.9171 109.524 29.0628C108.996 29.1951 108.481 29.2613 107.979 29.2613C106.487 29.2613 105.305 28.8179 104.434 27.931C103.576 27.044 103.147 25.8196 103.147 24.2576C103.147 23.2648 103.338 22.3911 103.721 21.6366C104.104 20.8688 104.639 20.2731 105.325 19.8495C106.025 19.4259 106.817 19.2141 107.702 19.2141C108.956 19.2141 109.953 19.6245 110.692 20.4452C111.431 21.2659 111.801 22.3779 111.801 23.781C111.801 24.0458 111.748 24.2377 111.643 24.3569C111.537 24.476 111.365 24.5356 111.128 24.5356H104.751C104.87 26.8124 105.946 27.9508 107.979 27.9508C108.494 27.9508 108.936 27.8846 109.306 27.7522C109.675 27.6066 110.072 27.4147 110.494 27.1764C110.837 26.9779 111.068 26.8786 111.187 26.8786ZM107.721 20.4651C106.876 20.4651 106.197 20.7298 105.682 21.2593C105.18 21.7888 104.883 22.5367 104.79 23.503H110.395C110.369 22.5235 110.124 21.7756 109.662 21.2593C109.2 20.7298 108.553 20.4651 107.721 20.4651Z"
            fill="white"
          />
          <path
            d="M121 19.7502C121.145 19.4325 121.376 19.2737 121.693 19.2737C121.891 19.2737 122.069 19.3399 122.228 19.4722C122.386 19.6046 122.465 19.7701 122.465 19.9686C122.465 20.0878 122.439 20.1937 122.386 20.2863L116.821 32.3192C116.755 32.4648 116.656 32.5773 116.524 32.6567C116.405 32.7361 116.28 32.7758 116.148 32.7758C115.95 32.7758 115.772 32.7097 115.613 32.5773C115.468 32.4582 115.395 32.2993 115.395 32.1007C115.395 31.9948 115.422 31.8889 115.475 31.783L116.861 28.7848L112.94 20.2863C112.887 20.1937 112.86 20.0944 112.86 19.9885C112.86 19.7899 112.946 19.6179 113.118 19.4722C113.303 19.3266 113.501 19.2538 113.712 19.2538C113.844 19.2538 113.969 19.2935 114.088 19.373C114.22 19.4524 114.319 19.5649 114.385 19.7105L117.693 27.1566L121 19.7502Z"
            fill="white"
          />
          <path
            d="M132.381 21.9344C133.186 22.1462 133.807 22.5433 134.242 23.1258C134.691 23.7082 134.916 24.4363 134.916 25.3099C134.916 26.541 134.513 27.4875 133.708 28.1494C132.902 28.798 131.76 29.1223 130.282 29.1223H125.291C125.04 29.1223 124.835 29.0495 124.677 28.9039C124.532 28.7583 124.459 28.5663 124.459 28.3281V15.918C124.459 15.6797 124.532 15.4878 124.677 15.3422C124.835 15.1966 125.04 15.1238 125.291 15.1238H130.064C131.503 15.1238 132.619 15.4415 133.411 16.0769C134.203 16.7122 134.599 17.6124 134.599 18.7773C134.599 19.5318 134.401 20.1804 134.005 20.7232C133.622 21.2659 133.081 21.6697 132.381 21.9344ZM126.063 21.3387H129.826C130.869 21.3387 131.655 21.1269 132.183 20.7033C132.724 20.2797 132.995 19.6642 132.995 18.8567C132.995 17.2682 131.939 16.474 129.826 16.474H126.063V21.3387ZM130.123 27.7721C131.219 27.7721 132.024 27.5735 132.539 27.1764C133.067 26.7661 133.331 26.1307 133.331 25.2702C133.331 23.5494 132.262 22.6889 130.123 22.6889H126.063V27.7721H130.123Z"
            fill="white"
          />
          <path
            d="M138.378 29.2216C138.14 29.2216 137.942 29.1554 137.784 29.023C137.639 28.8774 137.566 28.6789 137.566 28.4274V20.0481C137.566 19.7966 137.639 19.6046 137.784 19.4722C137.942 19.3266 138.14 19.2538 138.378 19.2538C138.616 19.2538 138.807 19.3266 138.952 19.4722C139.098 19.6046 139.17 19.7966 139.17 20.0481V28.4274C139.17 28.6921 139.098 28.8907 138.952 29.023C138.807 29.1554 138.616 29.2216 138.378 29.2216ZM138.378 17.1689C138.061 17.1689 137.804 17.0763 137.606 16.891C137.408 16.7056 137.309 16.4607 137.309 16.1563C137.309 15.8651 137.408 15.6268 137.606 15.4415C137.804 15.2561 138.061 15.1635 138.378 15.1635C138.695 15.1635 138.952 15.2561 139.151 15.4415C139.349 15.6268 139.448 15.8651 139.448 16.1563C139.448 16.4607 139.349 16.7056 139.151 16.891C138.952 17.0763 138.695 17.1689 138.378 17.1689Z"
            fill="white"
          />
          <path
            d="M147.021 19.2141C149.332 19.2141 150.487 20.4915 150.487 23.0463V28.4274C150.487 28.6789 150.414 28.8774 150.269 29.023C150.137 29.1554 149.946 29.2216 149.695 29.2216C149.444 29.2216 149.246 29.1554 149.101 29.023C148.955 28.8774 148.883 28.6789 148.883 28.4274V23.1456C148.883 22.2455 148.705 21.5902 148.348 21.1799C148.005 20.7695 147.45 20.5643 146.684 20.5643C145.8 20.5643 145.094 20.8357 144.565 21.3784C144.037 21.9212 143.773 22.6558 143.773 23.5825V28.4274C143.773 28.6789 143.701 28.8774 143.555 29.023C143.423 29.1554 143.232 29.2216 142.981 29.2216C142.73 29.2216 142.532 29.1554 142.387 29.023C142.242 28.8774 142.169 28.6789 142.169 28.4274V20.0481C142.169 19.8098 142.242 19.6179 142.387 19.4722C142.532 19.3266 142.73 19.2538 142.981 19.2538C143.219 19.2538 143.404 19.3266 143.536 19.4722C143.681 19.6179 143.753 19.8032 143.753 20.0282V21.0409C144.07 20.4452 144.513 19.9951 145.08 19.6907C145.648 19.373 146.295 19.2141 147.021 19.2141Z"
            fill="white"
          />
          <path
            d="M161.169 15.0245C161.419 15.0245 161.617 15.0973 161.763 15.2429C161.908 15.3885 161.98 15.5738 161.98 15.7989V28.4274C161.98 28.6656 161.908 28.8576 161.763 29.0032C161.617 29.1488 161.419 29.2216 161.169 29.2216C160.918 29.2216 160.72 29.1488 160.574 29.0032C160.442 28.8576 160.376 28.6656 160.376 28.4274V27.3551C160.086 27.964 159.657 28.434 159.089 28.7649C158.535 29.0958 157.881 29.2613 157.128 29.2613C156.283 29.2613 155.538 29.0495 154.891 28.6259C154.244 28.2023 153.742 27.6133 153.385 26.8587C153.029 26.091 152.851 25.204 152.851 24.198C152.851 23.2052 153.029 22.3315 153.385 21.577C153.742 20.8225 154.244 20.24 154.891 19.8297C155.538 19.4193 156.283 19.2141 157.128 19.2141C157.881 19.2141 158.535 19.3796 159.089 19.7105C159.657 20.0415 160.086 20.5114 160.376 21.1203V15.7989C160.376 15.5606 160.442 15.3753 160.574 15.2429C160.72 15.0973 160.918 15.0245 161.169 15.0245ZM157.445 27.931C158.383 27.931 159.102 27.6133 159.604 26.9779C160.119 26.3292 160.376 25.4158 160.376 24.2377C160.376 23.0596 160.119 22.1528 159.604 21.5174C159.102 20.882 158.383 20.5643 157.445 20.5643C156.508 20.5643 155.775 20.882 155.247 21.5174C154.732 22.1528 154.475 23.0463 154.475 24.198C154.475 25.3761 154.732 26.2961 155.247 26.958C155.775 27.6066 156.508 27.931 157.445 27.931Z"
            fill="white"
          />
          <path
            d="M172.418 26.8786C172.563 26.8786 172.689 26.9381 172.794 27.0573C172.9 27.1764 172.953 27.3287 172.953 27.514C172.953 27.8449 172.722 28.1494 172.26 28.4274C171.784 28.7053 171.283 28.9171 170.754 29.0628C170.226 29.1951 169.711 29.2613 169.21 29.2613C167.718 29.2613 166.536 28.8179 165.665 27.931C164.807 27.044 164.377 25.8196 164.377 24.2576C164.377 23.2648 164.569 22.3911 164.952 21.6366C165.335 20.8688 165.869 20.2731 166.556 19.8495C167.256 19.4259 168.048 19.2141 168.932 19.2141C170.187 19.2141 171.183 19.6245 171.923 20.4452C172.662 21.2659 173.032 22.3779 173.032 23.781C173.032 24.0458 172.979 24.2377 172.873 24.3569C172.768 24.476 172.596 24.5356 172.359 24.5356H165.982C166.1 26.8124 167.176 27.9508 169.21 27.9508C169.725 27.9508 170.167 27.8846 170.537 27.7522C170.906 27.6066 171.302 27.4147 171.725 27.1764C172.068 26.9779 172.299 26.8786 172.418 26.8786ZM168.952 20.4651C168.107 20.4651 167.427 20.7298 166.912 21.2593C166.411 21.7888 166.114 22.5367 166.021 23.503H171.626C171.599 22.5235 171.355 21.7756 170.893 21.2593C170.431 20.7298 169.784 20.4651 168.952 20.4651Z"
            fill="white"
          />
          <path
            d="M180.168 19.2538C180.723 19.2141 181 19.4392 181 19.9289C181 20.1407 180.941 20.3128 180.822 20.4452C180.703 20.5643 180.498 20.6371 180.208 20.6636L179.614 20.7232C178.729 20.8026 178.069 21.1203 177.633 21.6763C177.211 22.219 177 22.861 177 23.6023V28.4274C177 28.6921 176.927 28.8907 176.782 29.023C176.636 29.1554 176.445 29.2216 176.207 29.2216C175.97 29.2216 175.772 29.1554 175.613 29.023C175.468 28.8774 175.395 28.6789 175.395 28.4274V20.0481C175.395 19.7966 175.475 19.6046 175.633 19.4722C175.791 19.3266 175.983 19.2538 176.207 19.2538C176.419 19.2538 176.597 19.3266 176.742 19.4722C176.887 19.6046 176.96 19.7899 176.96 20.0282V21.1402C177.237 20.5577 177.627 20.1143 178.128 19.8098C178.643 19.5053 179.231 19.3266 179.891 19.2737L180.168 19.2538Z"
            fill="white"
          />
          <path
            d="M35.0655 27.6695C37.6409 27.6695 39.7286 25.5789 39.7286 23C39.7286 20.4211 37.6409 18.3304 35.0655 18.3304C32.4901 18.3304 30.4024 20.4211 30.4024 23C30.4024 25.5789 32.4901 27.6695 35.0655 27.6695Z"
            fill="white"
          />
          <path
            d="M45.8798 23C45.8798 17.0359 41.065 12.1975 35.115 12.1716V15.947C38.9824 15.9728 42.1097 19.1213 42.1097 23C42.1097 26.8787 38.9824 30.0272 35.115 30.053H33.7528C31.6703 30.053 29.9827 31.743 29.9827 33.8284H35.115C41.065 33.8026 45.8798 28.9641 45.8798 23Z"
            fill="white"
          />
          <path
            d="M0 23C0 28.9641 4.81489 33.8026 10.7648 33.8284V30.053C6.89741 30.0272 3.77016 26.8787 3.77016 23C3.77016 19.1213 6.89741 15.9728 10.7648 15.947H12.127C14.2095 15.947 15.8972 14.257 15.8972 12.1716H10.7648C4.81489 12.1975 0 17.0359 0 23Z"
            fill="white"
          />
          <path
            d="M22.9395 46C28.8953 46 33.7271 41.1784 33.7529 35.2203H29.9827C29.9569 39.093 26.8128 42.2246 22.9395 42.2246C19.0661 42.2246 15.922 39.093 15.8962 35.2203V33.8562C15.8962 31.7708 14.2086 30.0808 12.126 30.0808V35.2203C12.1518 41.1784 16.9836 46 22.9395 46Z"
            fill="white"
          />
          <path
            d="M22.9395 15.4989C25.5148 15.4989 27.6025 13.4083 27.6025 10.8294C27.6025 8.25045 25.5148 6.15982 22.9395 6.15982C20.3641 6.15982 18.2764 8.25045 18.2764 10.8294C18.2764 13.4083 20.3641 15.4989 22.9395 15.4989Z"
            fill="white"
          />
          <path
            d="M22.9395 39.8402C25.5148 39.8402 27.6025 37.7496 27.6025 35.1706C27.6025 32.5917 25.5148 30.5011 22.9395 30.5011C20.3641 30.5011 18.2764 32.5917 18.2764 35.1706C18.2764 37.7496 20.3641 39.8402 22.9395 39.8402Z"
            fill="white"
          />
          <path
            d="M22.9395 0C16.9836 0 12.1518 4.82156 12.126 10.7797H15.8962C15.922 6.90696 19.0661 3.77538 22.9395 3.77538C26.8128 3.77538 29.9569 6.90696 29.9827 10.7797V12.1438C29.9827 14.2292 31.6704 15.9192 33.7529 15.9192V10.7797C33.7271 4.82156 28.8953 0 22.9395 0Z"
            fill="white"
          />
          <path
            d="M22.9395 28.4644C25.9532 28.4644 28.3963 26.0179 28.3963 23C28.3963 19.9821 25.9532 17.5356 22.9395 17.5356C19.9258 17.5356 17.4827 19.9821 17.4827 23C17.4827 26.0179 19.9258 28.4644 22.9395 28.4644Z"
            fill="white"
          />
          <path
            d="M10.7856 27.6695C13.361 27.6695 15.4487 25.5789 15.4487 23C15.4487 20.4211 13.361 18.3304 10.7856 18.3304C8.2103 18.3304 6.12256 20.4211 6.12256 23C6.12256 25.5789 8.2103 27.6695 10.7856 27.6695Z"
            fill="white"
          />
        </svg>
      </router-link>
    </div>

    <div class="text-box">
      <h2 class="title-text">
        A few clicks away from achieving your goals.
      </h2>
      <p class="subtext">
        Create short, manageable and completable goals with the help of a
        <span>verified expert</span> upon registering.
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "Sidebar",
  data() {
    return {
      parentHeight: null
    };
  },
  methods: {
    sidebarHeight() {
      this.parentHeight = this.$parent.$el.offsetHeight;
      // this.parentHeight = this.$parent.$el.offsetHeight
      document.querySelector(".sidebar").style.height =
        this.parentHeight + "px";
    }
  },
  mounted() {
    if (window.innerWidth > 862) {
      this.sidebarHeight();
    }
    window.addEventListener("resize", () => {
      if (window.innerWidth > 862) {
        this.sidebarHeight();
      }
    });
  }
};
</script>

<style lang="scss" scoped>
$bp-sm: 576px;
$bp-md: 768px;
$bp-tab: 862px;
$bp-lg: 992px;
$bp-lap: 1024px;
$bp-xl: 1200px;
.sidebar {
  padding: 4rem;
  background-color: #557efb;
  width: 34%;
  float: left;
  height: 100vh;

  a {
    &:hover {
      box-shadow: none;
    }
  }

  .text-box {
    height: calc(100vh - 120px);
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    color: white;
    .title-text {
      color: #fff;
      font-weight: bold;
      font-size: 40px;
      line-height: 55px;
      margin-bottom: 40px;
      transform: translateY(-50%);
    }
    .subtext {
      transform: translateY(-50%);
      font-weight: normal;
      font-size: 24px;
      line-height: 33px;
      span {
        font-weight: bold;
      }
    }
  }
}
@media (max-width: $bp-xl) {
  .sidebar {
    .text-box {
      .title-text {
        transform: none;
      }
      .subtext {
        transform: none;
      }
    }
  }
}
@media (max-width: $bp-lap) {
  .sidebar {
    width: 40%;
    padding: 4rem 2rem;
  }
}
@media (max-width: $bp-tab) {
  .sidebar {
    width: 100%;
    height: auto !important;
    padding: 4rem;
    float: unset;
    .text-box {
      height: 100%;
      margin-top: 60px;
    }
  }
}
@media (max-width: $bp-sm) {
  .sidebar {
    .text-box {
      .title-text {
        font-size: 32px;
        margin-bottom: 20px;
        line-height: 38px;
      }
      .subtext {
        font-size: 18px;
      }
    }
  }
}
</style>
